import { rem } from "@certn/cascadia/utils";
import { CascadiaLayout, CascadiaSpacing } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import classNames from "classnames";
import { PropsWithChildren } from "react";

import { useMediaQuery } from "../../components/utils";
import { useLayout } from "../grid-layout/Layout";

export interface ContainerProps {
  className?: string;
  padding?: CascadiaSpacing[];
  layout?: CascadiaLayout;
  maxWidth?: number;
  testID?: string;
}

export function Container(props: PropsWithChildren<ContainerProps>) {
  const { mediaQuery } = useMediaQuery();
  const { layoutValues } = useLayout(props.layout);
  const { className, children, padding, testID = "container" } = props;

  return (
    <main
      className={classNames(
        css(
          mediaQuery({
            maxWidth: layoutValues.maxWidth,
            rowGap: layoutValues.gapHorizontal.map(rem),
            columnGap: layoutValues.gapVertical.map(rem),
            paddingTop: padding?.map(rem),
          })
        ),
        styles.content,
        props.maxWidth && css({ maxWidth: props.maxWidth }),
        className
      )}
      data-testid={testID}
    >
      {children}
    </main>
  );
}

const styles = {
  content: css({
    position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "stretch",
    justifyItems: "stretch",
    width: "100%",
  }),
};
